



























import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { ICatalogFilterItemOption } from '~/assets/interfaces/catalog'

@Component
export default class ComponentCatalogFilterRange extends Vue {
  @Prop({ type: Object, default: { min: 0, max: 0 } })
  private options!: ICatalogFilterItemOption

  @Watch('options')
  private optionsHandler(val: ICatalogFilterItemOption) {
    this.min = val.min
    this.max = val.max
  }

  private min = 0
  private max = 0

  private created(): void {
    this.min = this.options.min
    this.max = this.options.max
  }

  private isFocusFrom = false
  private isFocusTo = false

  private focusFrom() {
    this.isFocusFrom = true
  }

  private focusTo() {
    this.isFocusTo = true
  }

  private blurFrom() {
    this.isFocusFrom = false
  }

  private blurTo() {
    this.isFocusTo = false
  }

  private $style!: IStyle

  private get classItemFrom() {
    return {
      [this.$style.item]: true,
      [this.$style.focus]: this.isFocusFrom,
    }
  }

  private get classItemTo() {
    return {
      [this.$style.item]: true,
      [this.$style.focus]: this.isFocusTo,
    }
  }

  private changeHandlerFrom(e: Event) {
    let temp = Number((e.target as HTMLInputElement).value)
    if (isNaN(temp)) {
      temp = this.options.min
    }
    this.min = temp
    this.$emit('change', {
      min: temp,
      max: this.options.max,
    })
  }

  private changeHandlerTo(e: Event) {
    let temp = Number((e.target as HTMLInputElement).value)
    if (isNaN(temp)) {
      temp = this.options.max
    }
    this.max = temp
    this.$emit('change', {
      min: this.options.min,
      max: temp,
    })
  }
}
